import React, {useEffect, useRef, useState} from 'react';
import styles from "./UserAdministration.module.scss";
import {Tab, Tabs} from "@mui/material";
import {hasValue, saveSingleCadetValue, useDebouncedEffect} from "../../helpers/helperFunctions";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import {DataGrid} from "@mui/x-data-grid";
import TextInput from "../../Components/TextInput/TextInput";
import EditCadetModal from "./EditCadetModal";
import EditAdminModal from "./EditAdminModal";
import Button, {BUTTON_TYPE_SECONDARY} from "../../Components/Button/Button";
import {PROD_API_URL} from "../../constants/constants";
import toast from "react-hot-toast";
import {successToast} from "../../helpers/toastCSS";
import Papa from "papaparse";
import moment from "moment/moment";
import {saveAs} from "file-saver";
import TabSelector from "../../Components/TabSelector/TabSelector";
import UserChart from "./UserChart";
import BroadcastNotification from "./BroadcastNotification";
import NotificationAdministration from "./NotificationAdministration";

const adminWalletColumns = [
  { field: 'solanaWallet', headerName: 'Wallet', flex: 2},
  { field: 'name', headerName: 'Name', flex: 0.5},
  { field: 'canViewDashboard', headerName: 'Access Admin Dash', flex: 0.5},
  { field: 'canEditIdo', headerName: 'Edit IDO Data', flex: 0.5 },
  { field: 'isAdmin', headerName: 'Administrator', flex: 0.5 },
];

const cadetWalletColumns =
  [
    { field: 'username', headerName: 'Username', flex: 1},
    {
        field: 'profileImage',
        headerName: 'Picture',
        width: 80,
        renderCell: (params) => (
            params.value ? <img className={styles.profileImage} src={params.value} alt="profileImage"/> : ''
        )
    },
    {
        field: 'kycApproved',
        headerName: 'KYC',
        width: 100,
        renderCell: (params) => (
            params.value ? 'Yes' : 'No'
        )
    },
    { field: 'discordUsername', headerName: 'Discord', flex: 1,},
    { field: 'telegramUsername', headerName: 'Telegram', flex: 1},
    { field: 'twitterUsername', headerName: 'X/Twitter', flex: 1},
    {
        field: 'createdAt',
        headerName: 'Created At',
        flex: 1,
        renderCell: (params) => (
            moment.unix(params.value / 1000).format('YYYY-MM-DD , h:mm A')
        )
    },
    { field: 'email', headerName: 'Email', flex: 1},
    { field: 'solanaWallet', headerName: 'SOL Wallet', flex: 2},
    { field: 'ethereumWallet', headerName: 'ETH Wallet', flex: 0.5},
    { field: 'supraWallet', headerName: 'SUPRA Wallet', flex: 0.5},
    {
        field: 'updatedAt',
        headerName: 'Updated At',
        flex: 1,
        renderCell: (params) => (
            moment.unix(params.value / 1000).format('YYYY-MM-DD , h:mm A')
        )
    },
  ]

const TAB_CADET_ADMIN = 0;
const TAB_ADMIN_WALLET = 1;
const TAB_CHART_OVERVIEW = 2;
const TAB_NOTIFICATIONS = 3;

function UserAdministration() {
  const [adminWalletRows, setAdminWalletRows] = useState();
  const [cadetWalletRows, setCadetWalletRows] = useState();
  const [filteredCadetWalletRows, setFilteredCadetWalletRows] = useState();
  const [cadetWalletStatistics, setCadetWalletStatistics] = useState()
  const [chartData, setChartData] = useState();
  const [tab, setTab] = useState(TAB_CADET_ADMIN);
  const [cadetFilter, setCadetFilter] = useState();
  const [editModalData, setEditModalData] = useState();
  const [editAdminModalData, setEditAdminModalData] = useState();

  const tableRef = useRef();

  const fetchAdminWallets = async () => {
    fetch(PROD_API_URL+"/adminWallets/", {
      "method": "GET",
      "headers": {"content-type": "application/json", "accept": "*"},
    }).then(res=>res.json())
      .then((result)=>{
        setAdminWalletRows(result.data)

      });
  }

  const fetchCadetWallets = async () => {
    fetch(PROD_API_URL +"/cadetInfo/", {
      "method": "GET",
      "headers": {"content-type": "application/json", "accept": "*"},
    }).then(res=>res.json())
      .then((result)=>{
          console.log(result)
        calculateStatistics(result.data);
        let i = 0
        const mappedData = result.data.map(cadet => {
            cadet.id = i
            i++;
            return cadet;
        });
        setCadetWalletRows(mappedData)
        setFilteredCadetWalletRows(mappedData)

      });
  }

  useEffect( ()=>{

    fetchCadetWallets();
    fetchAdminWallets();
  },[]);

  const calculateStatistics = (rows) => {

    const finalResult = [];
    const keyBlacklist = ['createdAt', 'updatedAt', 'id', 'cadetId', 'solanaWallet']
    const chartData = new Map();

    rows.forEach(row => {
        const date = moment.unix(row.createdAt / 1000).format('YYYY-MM-DD');
        const value = {
            users: (chartData.get(date)?.users || 0) + 1,
            'kycApproved': (chartData.get(date)?.['kycApproved'] || 0),
        };
        if (row.kycApproved) {
            value['kycApproved'] = (chartData.get(date)?.['kycApproved'] || 0) + 1;
        }


        chartData.set(date, value);

      const deconstructed = Object.entries(row);
      deconstructed.forEach(value => {
        const walletKey = value[0];
        const walletValue = value[1];
        if (hasValue(walletValue) && !keyBlacklist.includes(walletKey)) {
          const foundIndex = finalResult[walletKey];
          if (foundIndex) {
            finalResult[walletKey] = finalResult[walletKey] + 1;
          } else {
            finalResult[walletKey] = 1
          }
        }
      })

    })

    setCadetWalletStatistics(finalResult);

      let totalUsers = 0;
      let kycApproved = 0;

      const chartDataArray = Array.from(chartData, ([key, value]) => {
          totalUsers = totalUsers + value.users;
          kycApproved = kycApproved + value['kycApproved'];
          return (
              {
                  date: key,
                  "Total Users": totalUsers,
                  "Users Per Day": value.users,
                  'KYC Approved Per Day': value['kycApproved'],
                  'Total KYC Approved': kycApproved,
              }
          )
      });

      setChartData(chartDataArray);
  }

  const filterRows = () => {
      if (!hasValue(cadetFilter)) return setFilteredCadetWalletRows(cadetWalletRows);

      const filteredCadetWallet = cadetWalletRows?.filter(row => {
          if (hasValue(row.discordUsername) && row.discordUsername.toLowerCase().includes(cadetFilter.toLowerCase())) return true;

          return row?.solanaWallet.includes(cadetFilter)
      });

      setFilteredCadetWalletRows(filteredCadetWallet);
  }

    useDebouncedEffect(() => {
        if (hasValue(cadetWalletRows)) {
            filterRows();
        }
    }, 500, [cadetFilter]);

  const handleFilter = (value) => {
    setCadetFilter(value);
  }

    const downloadCSV = async () => {
        const csv = Papa.unparse(cadetWalletRows);
        const filename = `cadets_${moment().format('YYYY-MM-DD')}.csv`;
        const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
        saveAs(blob, filename);
    }

    const tabOptions = [
        {key: TAB_CADET_ADMIN, label: 'Cadet Administration'},
        {key: TAB_ADMIN_WALLET, label: 'Admin Wallets'},
        {key: TAB_CHART_OVERVIEW, label: 'Chart Overview'},
        {key: TAB_NOTIFICATIONS, label: 'Notifications'},
    ];

    return (
    <main id="home" key="home" className={styles.mainIdoContainer}>
       <div className={styles.userAdminContainer}>
           <div className={styles.userAdminHeader}>
               <div className={styles.userAdministrationSwitch}>
                   <TabSelector
                       options={tabOptions}
                       setValue={setTab}
                       tabContainerClassName={styles.tabSelector}
                       value={tab} />
               </div>
               <div className={styles.userAdministrationActions}>
                   <Button text="Download CSV"  buttonType={BUTTON_TYPE_SECONDARY} onClick={downloadCSV}/>
               </div>
           </div>
           {tab === TAB_NOTIFICATIONS && <NotificationAdministration />}
           {tab === TAB_CHART_OVERVIEW && <UserChart data={chartData} />}
           {!adminWalletRows && tab === TAB_ADMIN_WALLET && <LoadingSpinner local/>}
           {adminWalletRows && tab === TAB_ADMIN_WALLET &&
               <>
                   <div className={styles.idoTableContainer}>
                       <DataGrid
                           apiRef={tableRef}
                           rows={adminWalletRows}
                           onCellDoubleClick={(params) => setEditAdminModalData(params.row)}
                           columns={adminWalletColumns}
                           initialState={{
                               pagination: {
                                   paginationModel: {page: 0, pageSize: 20},
                               },
                           }}
                           pageSizeOptions={[5, 10, 20]}
                       />
                   </div>
                   <div className={styles.cadetWalletToolbar}>
                       <Button
                           buttonType={BUTTON_TYPE_SECONDARY}
                           text="Add new admin wallet"
                           onClick={() => setEditAdminModalData({})}/>
                   </div>
               </>

           }
           {!filteredCadetWalletRows && tab === TAB_CADET_ADMIN && <LoadingSpinner local/>}
           {filteredCadetWalletRows && cadetWalletStatistics && tab === TAB_CADET_ADMIN &&
               <>
                   <div className={styles.cadetWalletToolbar}>
                   <div className={styles.filterContainer}>
                   <TextInput label="Filter SOL Wallet / Discord" setValue={handleFilter} value={cadetFilter}/>
                 </div>
                 <div className={styles.walletStatistics}>
                   <span>ETHEREUM: {cadetWalletStatistics.ethereumWallet}</span>
                   <span>POLYGON: {cadetWalletStatistics.polygonWallet}</span>
                   <span>ARBITRUM: {cadetWalletStatistics.arbitrumWallet}</span>
                   <span>SUPRA: {cadetWalletStatistics.supraWallet}</span>
                   <span>SUI: {cadetWalletStatistics.suiWallet}</span>
                   <span>AVALANCHE: {cadetWalletStatistics.avalancheWallet}</span>
                  <span>DYMENSION: {cadetWalletStatistics.dymensionWallet}</span>
                </div>
              </div>
             <div className={styles.idoTableContainer}>
               <DataGrid
                 apiRef={tableRef}
                 rows={filteredCadetWalletRows}
                 onCellDoubleClick={(params) => setEditModalData(params.row)}
                 columns={cadetWalletColumns}
                 initialState={{
                   pagination: {
                     paginationModel: { page: 0, pageSize: 10 },
                   },
                 }}
                 pageSizeOptions={[10, 15, 20]}
               />
             </div>

            </>

           }

         </div>
      {editAdminModalData && <EditAdminModal adminData={editAdminModalData} setAdminData={setEditAdminModalData} onComplete={fetchAdminWallets} /> }
      {editModalData && <EditCadetModal cadetData={editModalData} setCadetData={setEditModalData} />}
    </main>

  );
}

export default UserAdministration;
